import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { init as sentryInit } from '@sentry/angular';

import { environment } from '@client/environments/environment';

import { AppModule } from './app/app.module';

if (environment.sentryDSN) {
  sentryInit({
    dsn: environment.sentryDSN,
    release: environment.app_version,
    environment: environment.name
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
